import JottaTerms from '@jotta/config/JottaTerms'
import { getDetectedLocale } from '@jotta/i18n/locale'
import { ProseContainer } from '../components/ProseContainer'

export function JottaTermsAndConditions() {
  const locale = getDetectedLocale()
  const termsHtml = locale in JottaTerms ? JottaTerms[locale] : JottaTerms.en
  return (
    <ProseContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: termsHtml,
        }}
      />
    </ProseContainer>
  )
}
